const BASE = process.env.REACT_APP_API_URL || '';

async function request(path, opts = {}) {
  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...opts,
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw { status: res.status, ...data };
  }
  return res.json();
}

export const api = {
  url: (path) => `${BASE}${path}`,
  me: () => request('/auth/me'),
  login: () => { window.location.href = `${BASE}/auth/login`; },
  logout: () => request('/auth/logout'),
  calendars: () => request('/api/calendars'),
  disconnectCalendar: (calendarId) => request(`/auth/calendar/${calendarId}/disconnect`, { method: 'POST' }),
  deleteCalsyncBlock: (deleteAction) => request('/api/events/calsync-block', {
    method: 'DELETE',
    body: JSON.stringify({ delete_action: deleteAction }),
  }),
  syncPlan: (limit = 10) => request(`/api/sync/google-to-zoom/plan?limit=${encodeURIComponent(limit)}`),
  executeGoogleToZoomSync: ({ start, end, limit = 5 }) => request('/api/sync/google-to-zoom/execute', {
    method: 'POST',
    body: JSON.stringify({
      confirm: 'RUN_GOOGLE_TO_ZOOM_SYNC',
      start,
      end,
      limit,
    }),
  }),
  syncRules: () => request('/api/sync/rules'),
  updateSkipKeywords: (skipKeywords) => request('/api/sync/rules/skip-keywords', {
    method: 'PUT',
    body: JSON.stringify({ skip_keywords: skipKeywords }),
  }),
  events: (start, end) => {
    const params = new URLSearchParams();
    if (start) params.set('start', start);
    if (end) params.set('end', end);
    return request(`/api/events?${params}`);
  },
  authCalendar: (calendarId) => {
    window.location.href = `${BASE}/auth/calendar/${calendarId}`;
  },
};
